module.exports = __webpack_public_path__ + "static/media/wargames1.cb531dd4.gif";